import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type {
  PagedResponse,
  TicketRequestType,
  TicketRequestTypeStatus,
  TicketRequestTypeUpsert,
} from '../types'

const BASE = '/management/ticket-request-types'

/** Silinmemiş türlerin (sıralı) listesi. Lookup ölçeği küçük → tümünü tek sayfada çekeriz (size=200). */
export async function getTicketTypes(): Promise<PagedResponse<TicketRequestType>> {
  const { data } = await apiClient.get<PagedResponse<TicketRequestType>>(BASE, {
    params: { page: 0, size: 200 },
  })
  return data
}

/** Yeni tür oluştur (201 → oluşturulan kayıt). */
export async function createTicketType(body: TicketRequestTypeUpsert): Promise<TicketRequestType> {
  const { data } = await apiClient.post<TicketRequestType>(BASE, body)
  return data
}

/** Türü güncelle (ad; optimistic lock modDate zorunlu). */
export async function updateTicketType(
  id: number,
  body: TicketRequestTypeUpsert,
): Promise<TicketRequestType> {
  const { data } = await apiClient.put<TicketRequestType>(`${BASE}/${id}`, body)
  return data
}

/** Durum değiştir (Aktif/Pasif; yalnız 0↔1). */
export async function changeTicketTypeStatus(
  id: number,
  body: TicketRequestTypeStatus,
): Promise<TicketRequestType> {
  const { data } = await apiClient.put<TicketRequestType>(`${BASE}/${id}/status`, body)
  return data
}

/** Soft-delete (record_status=2). 204. */
export async function deleteTicketType(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}

/**
 * Yeniden sıralama — ekranda görünen tüm (silinmemiş) kayıtların id sırası. Backend bu sırayı 1..N
 * SORT_INDEX olarak yeniden yazar (pairwise takas değil; çift değeri onarır). 204.
 */
export async function reorderTicketTypes(orderedIds: number[]): Promise<void> {
  await apiClient.put(`${BASE}/reorder`, { orderedIds })
}

/**
 * Talep türlerini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportTicketTypes(): Promise<void> {
  await downloadXlsx(`${BASE}/export`, {}, 'talep-turleri.xlsx')
}
